import { selectBonuses } from "@/entities/bonus"
import { selectTransactions } from "@/pages/social-market-transactions/model"
import { useAppSelector } from "@/shared/lib/redux"
import { toLocaleString } from "@/shared/lib/to-locale-string"
import { Table } from "@/shared/ui/table"
import { ColumnDef } from "@tanstack/react-table"
import { format } from "date-fns"

export const HistoryTable = () => {
    const transactions = useAppSelector(selectTransactions)
    const bonuses = useAppSelector(selectBonuses)

    const cols: ColumnDef<typeof transactions[0], any>[] = [
        {
            accessorFn: (transaction) => transaction,
            id: 'price',
            enableSorting: false,
            cell: info => {
                const transaction = info.getValue()
                return (
                    <div className="text-white font-semibold text-[15px]">
                        {transaction.course}
                    </div>
                )
            },
            header: () => <div className="!text-start text-nowrap">Цена</div>,
        },
        {
            id: 'amount',
            enableSorting: false,
            accessorFn: (transaction) => transaction,
            header: () => <div className="!text-center text-nowrap">Обьем</div>,
            meta: {
                cellProps: {
                    className: 'w-full [&_div]:!justify-center'
                }
            },
            cell: info => {
                const transaction = info.getValue()
                return (
                    <div className="flex !justify-end">
                        <div className="flex items-center gap-[6px]">
                            <div className="text-white font-semibold text-[15px]">
                                {toLocaleString(transaction.amount)}
                            </div>
                            <div className="w-9 h-9 rounded-full overflow-hidden">
                                <img src={bonuses.find(bonus => bonus.id === transaction.bonus_id)?.image} className="w-full h-full object-contain" alt="" />
                            </div>
                        </div>
                    </div>
                )
            },
        },
        {
            id: 'date',
            enableSorting: false,
            accessorFn: (transaction) => transaction,
            cell: info => {
                const transaction = info.getValue()
                return (
                    <div className="flex items-end">
                        <div className="text-white text-end w-full">
                            {format(transaction.created_date, `dd.MM.yyyy`)}
                        </div>
                    </div>
                )
            },
            meta: {
                cellProps: {
                    className: 'w-full [&_div]:!justify-end'
                }
            },
            header: () => <div className="!text-end text-nowrap">Дата</div>,
        },
    ]
    return (
        <div className="p-5 max-w-[500px] shadow-md flex-1 !bg-color-dark rounded-2xl screen:rounded-3xl">
            <div className=" h-full no-scrollbar">
                <Table
                    columns={cols}
                    data={transactions}
                    classNames={{
                        table: '[&_th]:!border-[#E7EAEE88] [&_td]:!border-[#E7EAEE44]',
                        thead: 'table table-fixed w-full',
                        tbody: 'max-h-[400px] overflow-y-scroll block [&_tr]:table [&_tr]:table-fixed [&_tr]:w-full !w-full'
                    }}
                />
            </div>
        </div>
    )
}